import { adminConstants } from '../constant/admin-constant';

const initialState = {loading: false, editFestival:'', users:[], editCheck: false};
export function festivalReducer(state = initialState, action){

	// console.log('action.type', action.type);
	switch(action.type){
		case adminConstants.PAGINATION_FESTIVAL_REQUEST:
			return { ...state, loading:true }
		case adminConstants.PAGINATION_FESTIVAL_SUCCESS:
			return {  
				festivalData: action.payload.company.data,
        		festivalPages : action.payload.company.last_page,
        		//firstLoginFlag : true,
        		loading: false 
        	};
		case adminConstants.PAGINATION_FESTIVAL_FAILURE:
			return { loading:false, error:action.payload };

		case adminConstants.GET_FESTIVAL_REQUEST:
			return { ...state, loading:true };
		case adminConstants.GET_FESTIVAL_SUCCESS:
			return { loading:false, editFestival : action.payload.festival };
		case adminConstants.GET_FESTIVAL_FAILURE:
			return { loading:false, error : action.payload };

		case adminConstants.GET_FESTIVAL_COMMENTS_REQUEST:
			return { ...state, loading:true, festivalComments:[] };
		case adminConstants.GET_FESTIVAL_COMMENTS_SUCCESS:
			return { ...state, loading:false, festivalComments : action.payload.festivalComments };
		case adminConstants.GET_FESTIVAL_COMMENTS_FAILURE:
			return { loading:false, error : action.payload };

		case adminConstants.GET_FESTIVAL_MUSIC_DIRECTORS_REQUEST:
			return { ...state, loading:true, editCheck: false };
		case adminConstants.GET_FESTIVAL_MUSIC_DIRECTORS_SUCCESS:
			return { ...state, loading:false , users:action.payload.musicDirectors, festival:action.payload.festival,editCheck: true};
		case adminConstants.GET_FESTIVAL_MUSIC_DIRECTORS_FAILURE:
			return { loading:false, error : action.payload, editCheck: false };

		case adminConstants.GET_FESTIVAL_ADJUDICATORS_REQUEST:
			return { ...state, loading:true, editCheck: false };
		case adminConstants.GET_FESTIVAL_ADJUDICATORS_SUCCESS:
			return { ...state, loading:false , adjudicators:action.payload.adjudicators, festival:action.payload.festival,editCheck: true};
		case adminConstants.GET_FESTIVAL_ADJUDICATORS_FAILURE:
			return { loading:false, error : action.payload, editCheck: false };

		case adminConstants.STORE_FESTIVAL_MUSIC_DIRECTOR_REQUEST:
			return { ...state, loading:true }
		case adminConstants.STORE_FESTIVAL_MUSIC_DIRECTOR_SUCCESS:
			return { ...state, loading:false, editUser:'' };
		case adminConstants.STORE_FESTIVAL_MUSIC_DIRECTOR_FAILURE:
			return { ...state, loading:false, error:action.payload };

		case adminConstants.STORE_FESTIVAL_ADJUDICATOR_REQUEST:
			return { ...state, loading:true }
		case adminConstants.STORE_FESTIVAL_ADJUDICATOR_SUCCESS:
			return { ...state, loading:false, editAdjudicator:'' };
		case adminConstants.STORE_FESTIVAL_ADJUDICATOR_FAILURE:
			return { ...state, loading:false, error:action.payload };

		case adminConstants.GET_FESTIVAL_MUSIC_DIRECTOR_REQUEST:
			return { ...state, loading:true };
		case adminConstants.GET_FESTIVAL_MUSIC_DIRECTOR_SUCCESS:
			return { ...state, loading:false, editUser: action.payload.musicDirector };
		case adminConstants.GET_FESTIVAL_MUSIC_DIRECTOR_FAILURE:
			return { loading:false, error : action.payload };

		case adminConstants.GET_FESTIVAL_ADJUDICATOR_REQUEST:
			return { ...state, loading:true };
		case adminConstants.GET_FESTIVAL_ADJUDICATOR_SUCCESS:
			return { ...state, loading:false, editAdjudicator: action.payload.adjudicator };
		case adminConstants.GET_FESTIVAL_ADJUDICATOR_FAILURE:
			return { loading:false, error : action.payload };

		case adminConstants.DELETE_FESTIVAL_REQUEST:
			return { ...state, loading:true }
		case adminConstants.DELETE_FESTIVAL_SUCCESS:
			return { ...state, loading:false };
		case adminConstants.DELETE_FESTIVAL_FAILURE:
			return { loading:false, error:action.payload };

		case adminConstants.DELETE_FESTIVAL_MUSIC_DIRECTOR_REQUEST:
			return { ...state, loading:true }
		case adminConstants.DELETE_FESTIVAL_MUSIC_DIRECTOR_SUCCESS:
			return { ...state, loading:false };
		case adminConstants.DELETE_FESTIVAL_MUSIC_DIRECTOR_FAILURE:
			return { loading:false, error:action.payload };

		case adminConstants.DELETE_FESTIVAL_ADJUDICATOR_REQUEST:
			return { ...state, loading:true }
		case adminConstants.DELETE_FESTIVAL_ADJUDICATOR_SUCCESS:
			return { ...state, loading:false };
		case adminConstants.DELETE_FESTIVAL_ADJUDICATOR_FAILURE:
			return { loading:false, error:action.payload };
		
		case adminConstants.EDIT_FESTIVAL_MUSIC_DIRECTORS_REQUEST:
			return { ...state, loading:true, editCheck: false };
		case adminConstants.EDIT_FESTIVAL_MUSIC_DIRECTORS_SUCCESS:
			return { ...state, loading:false , editUser:action.payload.musicDirector, editCheck:true};
		case adminConstants.EDIT_FESTIVAL_MUSIC_DIRECTORS_FAILURE:
			return { ...state, loading:false, error : action.payload, editCheck:false };

		case adminConstants.EDIT_FESTIVAL_ADJUDICATOR_REQUEST:
			return { ...state, loading:true, editCheck: false };
		case adminConstants.EDIT_FESTIVAL_ADJUDICATOR_SUCCESS:
			return { ...state, loading:false , editAdjudicator:action.payload.adjudicator, editCheck:true};
		case adminConstants.EDIT_FESTIVAL_ADJUDICATOR_FAILURE:
			return { ...state, loading:false, error : action.payload, editCheck:false };
		

		case adminConstants.GET_FESTIVAL_ALL_MUSIC_DIRECTORS_REQUEST:
			return { ...state, loading:true }
		case adminConstants.GET_FESTIVAL_ALL_MUSIC_DIRECTORS_SUCCESS:
			return {  
				festivalAllMusicDirectorsData: action.payload.allMusicDirectors.data,
        		festivalAllMusicDirectorsPages : action.payload.allMusicDirectors.last_page,
        		loading: false 
        	};
		case adminConstants.GET_FESTIVAL_ALL_MUSIC_DIRECTORS_FAILURE:
			return { loading:false, error:action.payload };


		case adminConstants.GET_FESTIVAL_ALL_ADJUDICATORS_REQUEST:
			return { ...state, loading:true }
		case adminConstants.GET_FESTIVAL_ALL_ADJUDICATORS_SUCCESS:
			return {  
				festivalAllAdjudicatorsData: action.payload.allAdjudicators.data,
        		festivalAllAdjudicatorsPages : action.payload.allAdjudicators.last_page,
        		loading: false 
        	};
		case adminConstants.GET_FESTIVAL_ALL_ADJUDICATORS_FAILURE:
			return { loading:false, error:action.payload };

		case adminConstants.GET_PRICE_PER_ADJUDICATION_REQUEST:
			return { ...state, loading:true, editCheck: false };
		case adminConstants.GET_PRICE_PER_ADJUDICATION_SUCCESS:
			return { ...state, loading:false , pricePerAdjudicator:action.payload.pricePerAdjudicator};
		case adminConstants.GET_PRICE_PER_ADJUDICATION_FAILURE:
			return { ...state, loading:false, error : action.payload };

		case adminConstants.STORE_MDMEDIA_REQUEST:
			return { ...state, loading:true }
		case adminConstants.STORE_MDMEDIA_SUCCESS:
			return { ...state, loading:false, storeMDMedia: action.payload.storeMDMedia};
		case adminConstants.STORE_MDMEDIA_FAILURE:
			return { ...state, loading:false, error:action.payload };

		case adminConstants.GET_MDMEDIA_REQUEST:
			return { ...state, loading:true }
		case adminConstants.GET_MDMEDIA_SUCCESS:
			return { ...state, loading:false, MDMediaList: action.payload.MDMediaList, MDFestival: action.payload.Festival };
		case adminConstants.GET_MDMEDIA_FAILURE:
			return { ...state, loading:false, error:action.payload };
		
		case adminConstants.DELETE_MDMEDIA_REQUEST:
			return { ...state, loading:true }
		case adminConstants.DELETE_MDMEDIA_SUCCESS:
			return { ...state, loading:false, deleteMDMedia: action.payload.deleteMDMedia};
		case adminConstants.DELETE_MDMEDIA_FAILURE:
			return { ...state, loading:false, error:action.payload };

		default:
			return { ...state };
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/FestivalReducer.jsx